// views/mozo/MozoLayout.jsx
import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import SidebarMozo from '../Mozo/SidebarMozo';
import '../../styles/sidebar.css';


const MozoLayout = () => {
  const { slug } = useParams();

  return (
    <div className="layout-wrapper">
      <SidebarMozo slug={slug} />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default MozoLayout;
